import Types from "./Types";

export const getAdminNotificationsRequest = () => ({
  type: Types.GET_ADMIN_NOTIFICATIONS_REQUEST,
});

export const getAdminNotificationsSuccess = (data) => ({
  type: Types.GET_ADMIN_NOTIFICATIONS_SUCCESS,
  payload: data,
});

export const getAdminNotificationsFail = (error) => ({
  type: Types.GET_ADMIN_NOTIFICATIONS_FAIL,
  payload: error,
});

export const addAdminNotificationsLoading = (isLoading) => ({
  type: Types.ADD_ADMIN_NOTIFICATIONS_LOADING,
  payload: isLoading,
});

